/*jshint esversion: 6 */
import classes from "dom-classes";
import { Expo, Power4, TweenMax } from "gsap";
import PubSub from "pubsub-js";
import CustomEase from "../../vendors/CustomEase";
const $ = require("jquery");

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
require("slick-carousel/slick/slick.js");

import { isIE9 } from "../helpers";
import BaseSmoothWithTouch from "../scrollTouch";
// import {debounce} from 'this';

export default class HorizontalScroll extends BaseSmoothWithTouch {
  constructor(opt) {
    classes.remove(opt.section, "no-js");

    super(opt);
    this.createExtraBound();
    console.log(opt);
    this.resizing = false;
    this.animating = false;
    this.cache = null;
    this.vars.target = 0;
    this.url = opt.url;
    this.dom.divs = Array.prototype.slice.call(opt.divs, 0);
    this.dom.pageContainerFront = opt.pageContainerFront;
    this.dom.pageContainerBack = opt.pageContainerBack;
    this.runningAnimations = [];
    this.dom.header = $(opt.header);
    this.dom.logo = $(opt.logo);
    this.dom.navigation = $(opt.section).next();
    this.dom.lasthover = null;
    this.native = opt.native;
    this.onlyProjects = $(this.dom.pageContainerFront)
      .find(".page")
      .not(".page__work-with-us, .clients-block");
    this.currentOpen = null;

    this.mouseXPos = window.mouseXPos || null;

    if (this.url) {
      this.closeMenuPage(this.url);
      ["setEvents", "initialLoad"].forEach((fn) => this[fn].apply(this));
    } else {
      setTimeout(
        () => {
          this.initialLoad();

          TweenMax.set(
            [this.dom.pageContainerFront, this.dom.pageContainerBack],
            { x: -1000 }
          );
          TweenMax.to(
            [this.dom.pageContainerFront, this.dom.pageContainerBack],
            2.5,
            {
              x: 0,
              ease: Expo.easeInOut,
              onComplete: () => {
                this.setEvents();
                this.on();
              },
            }
          );
        },
        document.cookie.indexOf("visited=") == -1
          ? 0
          : window.firstLoad
          ? 500
          : 0
      );
    }
    window.firstLoad = false;
    window.smoothScrollInstances.push(this);

    if (isIE9()) {
      classes.add(this.dom.section, "scrollbar-mode");
    }
  }

  initialLoad() {
    var that = this;
    if (this.url) {
      TweenMax.set($(this.dom.pageContainerFront).find("p"), {
        autoAlpha: 1,
        y: 0,
      });
      return;
    }

    TweenMax.set($(this.dom.pageContainerFront).find("p"), {
      autoAlpha: 0,
      y: 50,
    });
    $(this.dom.pageContainerFront)
      .children()
      .each(function (index, el) {
        setTimeout(() => {
          TweenMax.staggerTo(
            $(el).find("p"),
            0.8,
            {
              autoAlpha: 1,
              y: 0,
              ease: Expo.easeInOut,
            },
            0.05
          );
        }, index + 1 + "00");
      });
  }

  createExtraBound() {
    [
      "getCache",
      "inViewport",
      "setEvents",
      "handleMouseOver",
      "handleMouseLeave",
    ].forEach((fn) => (this[fn] = this[fn].bind(this)));
  }

  setEvents() {
    PubSub.subscribe("RemoveScrollEvents", () => {
      this.off(); //remove all event handlers
    });

    PubSub.subscribe("mouseOver", (message, el) => {
      //event handler to hover mover the page before page closes, called in closeMenuPage
      this.handleMouseOver(null, el, 0);
    });
  }

  closeMenuPage(url) {
    const element = $(this.dom.pageContainerFront)
        .find(`a[href="${url}"]`)
        .closest(".page"),
      screenWidth = window.innerWidth,
      elementWidth = screenWidth / 3,
      pageContainerFront = element.closest(".pages-container"),
      pageContainerBack = pageContainerFront.siblings(".container--back"),
      navigation = pageContainerFront
        .closest(".horizontal-scroll")
        .siblings(".horizontal-scroll--navigation"),
      backElement = $(pageContainerBack).children().eq(element.index()),
      pageImage = backElement.find(".page--image");

    if (element.length) {
      PubSub.publish("mouseOver", element); //trigger mouse over on element to show color, text and image

      // put element into screen calculations
      const easeValue = this.vars.ease;
      this.vars.ease = 1;
      this.vars.target = Math.round(
        Math.max(
          0,
          Math.min(
            elementWidth * (element.index() - 1),
            elementWidth * (this.dom.divs.length / 2) - screenWidth
          )
        )
      );

      setTimeout(() => {
        //scroll element into view
        this.vars.ease = easeValue;

        let offset = element.offset().left;
        const direction = offset < 0 ? "left" : "right",
          initialOffset = element.offset().left,
          initialWidth = element.width(),
          maskEase = CustomEase.create(
            "custom",
            "M0,0,C0.29,0,0.252,0.344,0.29,0.502,0.38,0.982,0.704,1,1,1"
          ),
          elementRight = backElement.hasClass("animation-right"),
          pageImageFlow = {};

        //Page close transition and initial properties
        pageImageFlow.setRight = { /*x: '30%', y: '10%',*/ autoAlpha: 0 }; //If it has to open from right
        pageImageFlow.setLeft = { /*x: '-50%', y: '10%',*/ autoAlpha: 0 }; //If it has to open from left
        pageImageFlow.setAnimateRight = {
          /*x: '-25%', y: '0', scale: 1, */ autoAlpha: 1,
          delay: 1.3,
          ease: maskEase,
          onComplete: () => {
            TweenMax.set(pageImage, { clearProps: "all" });
            TweenMax.staggerTo(
              element.find("p"),
              1,
              { y: -100, autoAlpha: 1, ease: Expo.easeInOut },
              0.03
            );
          },
        };
        pageImageFlow.setAnimateLeft = {
          /*x: '5%', y: '0', scale: 1, */ autoAlpha: 1,
          delay: 1.3,
          ease: maskEase,
          onComplete: () => {
            TweenMax.set(pageImage, { clearProps: "all" });
            TweenMax.staggerTo(
              element.find("p"),
              1,
              { y: -100, autoAlpha: 1, ease: Expo.easeInOut },
              0.03
            );
          },
        };

        TweenMax.set(element.find("p"), { y: 0, autoAlpha: 0 });
        TweenMax.set([element, backElement], {
          width: screenWidth,
          x: -initialOffset,
        }); //Move element to start of screen
        TweenMax.set(
          [element.nextAll().slice(0, 4), backElement.nextAll().slice(0, 4)],
          { x: initialOffset }
        ); //Move element's sibblings along with element
        TweenMax.set(
          [element.prevAll().slice(0, 4), backElement.prevAll().slice(0, 4)],
          { x: -initialOffset }
        ); //Move element's sibblings along with element
        TweenMax.set(
          pageImage,
          elementRight ? pageImageFlow.setRight : pageImageFlow.setLeft
        ); //if logo has to come from right

        TweenMax.to([element, backElement], 1, {
          //change element width from expnded to it's initial width
          x: 0,
          width: initialWidth,
          delay: 1.3,
          ease: Power4.easeInOut,
        });
        TweenMax.to(
          [element.nextAll().slice(0, 4), backElement.nextAll().slice(0, 4)],
          1,
          { x: 0, delay: 1.3, ease: Power4.easeInOut }
        ); //move sibblings to their initial place
        TweenMax.to(
          [element.prevAll().slice(0, 4), backElement.prevAll().slice(0, 4)],
          1,
          { x: 0, delay: 1.3, ease: Power4.easeInOut }
        ); //move sibblings to their initial place
        TweenMax.to(
          pageImage,
          0.3,
          elementRight
            ? pageImageFlow.setAnimateRight
            : pageImageFlow.setAnimateLeft
        ); //Show page image based on the animation direction
      }, 200);
    }
  }

  handleMouseOver(e, page = null, time = 100) {
    const that = this,
      element = page || $(e.currentTarget);
    if (
      this.resizing ||
      this.animating ||
      (element.hasClass("hovering") && this.mouseXPos)
    )
      return;
    this.currentOpen = element.index();

    setTimeout(() => {
      this.handleMouseLeave(element);

      if (element.offset().left >= window.innerWidth - (element.width() + 50)) {
        this.dom.header.addClass("change-color");
        this.dom.navigation.addClass("right-change-color");
      } else if (element.offset().left < 30) {
        this.dom.navigation.addClass("left-change-color");
      }

      element.addClass("hovering").parent().addClass("hovering");
      $(this.dom.pageContainerBack)
        .children()
        .eq(element.index())
        .addClass("hovering");

      const anim = (element.animation = TweenMax.staggerTo(
        element.find("p"),
        0.6,
        { y: -100, ease: Expo.easeInOut },
        0.03
      ));
      this.runningAnimations.push(anim);
    }, time);
  }

  handleMouseLeave(e) {
    const that = this,
      element = $(e).siblings(".hovering");
    if (this.resizing || this.animating) return;

    this.dom.header.removeClass("change-color");
    this.dom.navigation.removeClass("right-change-color left-change-color");

    element.removeClass("hovering").parent().removeClass("hovering");
    $(this.dom.pageContainerBack)
      .children()
      .eq(element.index())
      .removeClass("hovering");

    this.runningAnimations.forEach((animations, index) => {
      animations.forEach((animation) => animation.kill());
      this.runningAnimations.splice(index, 1);
    });

    TweenMax.staggerTo(
      element.find("p").get().reverse(),
      0.6,
      { y: 0, ease: Expo.easeInOut },
      0.03
    );
  }

  resize() {
    this.resizing = true;

    this.getCache();
    super.resize();

    if (this.native) {
      this.dom.scroll.style.width = "";
      this.dom.scroll.style.height = `${this.vars.bounding}px`;
    }

    if (isIE9()) {
      this.dom.section.style.width = this.vars.width + window.innerWidth + "px";
    }

    this.resizing = false;
  }

  getCache() {
    this.cache = [];

    const unit =
      window.innerWidth > 1000
        ? this.vars.width / 3
        : window.innerWidth > 480
        ? this.vars.width / 2
        : this.vars.width / 1;

    this.dom.divs.forEach((el, index) => {
      el.style.display = "inline-block";
      //el.style.transform = 'none';
      el.style.width = `${unit}px`;

      const scrollX = this.vars.target;
      const bounding = el.getBoundingClientRect();
      const bounds = {
        el: el,
        state: true,
        left: bounding.left + scrollX,
        right: bounding.right + scrollX,
        center: unit / 2,
      };

      this.cache.push(bounds);
    });

    this.dom.section.style.width = `${this.vars.width}px`;
    this.vars.bounding = (unit * this.dom.divs.length) / 2 - this.vars.width;
  }

  run() {
    if (
      this.vars.current > this.vars.target - 100 &&
      this.vars.current < this.vars.target + 100 &&
      this.mouseXPos &&
      !this.resizing &&
      window.innerWidth > 1000
    ) {
      $(this.dom.pageContainerFront)
        .children()
        .eq(
          Math.floor(
            (this.mouseXPos + this.vars.current) / (window.innerWidth / 3)
          )
        )
        .trigger("mouseenter");
    }
    // this.dom.divs.forEach(this.inViewport);
    this.vars.current > 30
      ? this.dom.navigation.find(".navigation--left").addClass("active")
      : this.dom.navigation.find(".navigation--left").removeClass("active");

    this.vars.current >= this.vars.bounding - 50
      ? this.dom.navigation.find(".navigation--right").removeClass("active")
      : this.dom.navigation.find(".navigation--right").addClass("active");

    this.dom.section.style[this.prefix] = this.getTransform(
      this.vars.current * -1
    );

    // (this.vars.current > (this.vars.bounding - (window.innerWidth / 3) )) ? this.dom.header.addClass('change-color') : this.dom.header.removeClass('change-color');
    this.vars.current + window.innerWidth >
    this.onlyProjects.length * (window.innerWidth / 3)
      ? this.dom.header.addClass("change-color")
      : this.dom.header.removeClass("change-color");
    this.currentOpen != null && this.currentOpen == 0
      ? this.dom.logo.addClass("change-color")
      : this.dom.logo.removeClass("change-color");

    super.run();
  }

  calc(e) {
    if (this.animating) return;

    const delta = e.deltaY || e.deltaX;

    this.vars.target += delta * -1;
    this.clampTarget();
  }

  on() {
    super.on();

    $(this.dom.pageContainerFront)
      .children()
      .on("mouseenter", this.handleMouseOver);

    $(document).on("mousemove", (e) => (this.mouseXPos = e.clientX));

    this.dom.navigation.on("click", "button", (e) => {
      //functionality for arrow buttons
      const scrollAmount = window.outerWidth / 3;
      const el = $(e.currentTarget);
      if (el.hasClass("navigation--left")) {
        this.scrollTo(this.vars.current - scrollAmount);
      } else {
        this.scrollTo(this.vars.current + scrollAmount);
      }
    });
  }

  off() {
    super.off();

    $(document).off("mousemove");

    $(this.dom.pageContainerFront).children().off("mouseenter");

    $(this.dom.pageContainerFront)
      .children()
      .off("mouseenter", this.handleMouseOver);

    // this.pageSlider.slick('unslick');
  }

  mouseDown(e) {
    console.log(e);
  }

  inViewport(el, index) {
    if (!this.cache || this.resizing) return;

    const cache = this.cache[index];
    const current = this.vars.current;
    const left = Math.round(cache.left - current);
    const right = Math.round(cache.right - current);
    const inview = right > 0 && left < this.vars.width;

    if (inview) {
      // if( (this.mouse >= $(el).offset().left && this.mouse <= ($(el).offset().left + $(el).width()) ) && !el.state) {
      //     el.state = true;
      //     $(el).trigger('mouseenter').siblings();
      // }
    } else {
      el.state = false;
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/scrolling/horizontal-scroll.js